/* src/app/components/controls/sem-regex-input/sem-regex-input.component.css */
.museumCodeLetters {
  font-size: 14px;
  font-weight: lighter;
  padding-right: 4px;
}
.museumCodeLetters::after {
  content: " ";
}
/*# sourceMappingURL=sem-regex-input.component.css.map */
